import { FOUNDERS_PROD_HOST, MAIN_PROD_HOST, PARTNER_PROD_HOST } from '../../constants';

export const isProd = (host: string | null): boolean => {
  return host === MAIN_PROD_HOST || host === FOUNDERS_PROD_HOST || host === PARTNER_PROD_HOST;
};

export const isMainProd = (host: string | null): boolean => {
  return host === MAIN_PROD_HOST;
};
